var map = {
	"./pr-1.png": "76a6",
	"./pr-10.png": "e7de",
	"./pr-11.png": "a712",
	"./pr-12.png": "7560",
	"./pr-13.png": "696a",
	"./pr-14.png": "816c",
	"./pr-15.png": "b991",
	"./pr-16.png": "920a",
	"./pr-2.png": "a0f0",
	"./pr-3.png": "bdf9",
	"./pr-4.png": "8f85",
	"./pr-5.png": "6cac",
	"./pr-6.png": "4402",
	"./pr-7.png": "5a8e",
	"./pr-8.png": "d799",
	"./pr-9.png": "d1b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "54ae";